export default {
    zh: {
        title: '作品提交中心',
        subtitle: 'Creator Submission Portal',
        category: '作品分类',
        video: '视频',
        imageText: '图文',
        publishTime: '发布时间',
        selectTime: '选择一个时间',
        link: '社媒帖子链接',
        supported: '支持平台: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: '注意: 内容必须包含 "weryai.com/creation/"',
        submit: '提交审核',
        auditInfo: '请确保您的社交媒体帖子是公开的，并且帖子的内容必须包含 "weryai.com"的相关链接。',
        messages: {
            fillLink: '请填写链接',
            invalidLink: '链接格式不正确',
            httpsRequired: '请提交 https 链接',
            unsupportedHost: '暂不支持该平台',
            selectType: '请选择内容类型',
            selectPublishTime: '请选择发布时间',
            submitSuccess: '提交成功',
            submitFailed: '提交失败'
        }
    },
    en: {
        title: 'Creator Submission Center',
        subtitle: 'Creator Submission Portal',
        category: 'Work Category',
        video: 'Video',
        imageText: 'Image/Text',
        publishTime: 'Publish Time',
        selectTime: 'Select a time',
        link: 'Social Media Post Link',
        supported: 'Supported: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Note: Content must include "weryai.com/creation/"',
        submit: 'Submit for Audit',
        auditInfo: 'Please make sure your social media post is public, and the post content must include a related link to "weryai.com".',
        messages: {
            fillLink: 'Please fill in the link',
            invalidLink: 'Invalid link format',
            httpsRequired: 'Please submit an https link',
            unsupportedHost: 'This platform is not supported yet',
            selectType: 'Please select content type',
            selectPublishTime: 'Please select publish time',
            submitSuccess: 'Submission successful',
            submitFailed: 'Submission failed'
        }
    },
    ja: {
        title: 'クリエイター投稿センター',
        subtitle: 'Creator Submission Portal',
        category: '作品カテゴリー',
        video: '動画',
        imageText: '画像/テキスト',
        publishTime: '公開時間',
        selectTime: '时间を選択',
        link: 'ソーシャルメディアのリンク',
        supported: 'サポート対象: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: '注意: コンテンツには "weryai.com/creation/" を含める必要があります',
        submit: '審査に提出',
        auditInfo: 'ソーシャルメディアの投稿が公開されていること、そして投稿内容に「weryai.com」への関連リンクが含まれていることを確認してください。',
        messages: {
            fillLink: 'リンクを入力してください',
            invalidLink: 'リンクの形式が正しくありません',
            httpsRequired: 'https リンクを送信してください',
            unsupportedHost: 'このプラットフォームは現在サポートされていません',
            selectType: 'コンテンツタイプを選択してください',
            selectPublishTime: '公開時間を選択してください',
            submitSuccess: '送信に成功しました',
            submitFailed: '送信に失敗しました'
        }
    },
    ko: {
        title: '크리에이터 제출 센터',
        subtitle: 'Creator Submission Portal',
        category: '작품 카테고리',
        video: '동영상',
        imageText: '이미지/텍스트',
        publishTime: '게시 시간',
        selectTime: '시간 선택',
        link: '소셜 미디어 게시물 링크',
        supported: '지원 플랫폼: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: '참고: 콘텐츠에 "weryai.com/creation/"이 포함되어야 합니다',
        submit: '심사 제출',
        auditInfo: '소셜 미디어 게시물이 공개 상태이며, 게시물 내용에 "weryai.com" 관련 링크가 반드시 포함되어 있는지 확인해 주세요.',
        messages: {
            fillLink: '링크를 입력해 주세요',
            invalidLink: '링크 형식이 올바르지 않습니다',
            httpsRequired: 'https 링크를 제출해 주세요',
            unsupportedHost: '현재 이 플랫폼은 지원되지 않습니다',
            selectType: '콘텐츠 유형을 선택해 주세요',
            selectPublishTime: '게시 시간을 선택해 주세요',
            submitSuccess: '제출 성공',
            submitFailed: '제출 실패'
        }
    },
    es: {
        title: 'Centro de Envío para Creadores',
        subtitle: 'Creator Submission Portal',
        category: 'Categoría de Trabajo',
        video: 'Video',
        imageText: 'Imagen/Texto',
        publishTime: 'Hora de Publicación',
        selectTime: 'Seleccionar una hora',
        link: 'Enlace de la Publicación en Redes Sociales',
        supported: 'Soportado: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Nota: El contenido debe incluir "weryai.com/creation/"',
        submit: 'Enviar para Auditoría',
        auditInfo: 'Asegúrese de que su publicación en redes sociales sea pública y que el contenido de la publicación incluya obligatoriamente un enlace relacionado con "weryai.com".',
        messages: {
            fillLink: 'Por favor, complete el enlace',
            invalidLink: 'Formato de enlace no válido',
            httpsRequired: 'Por favor, envíe un enlace https',
            unsupportedHost: 'Esta plataforma aún no es compatible',
            selectType: 'Por favor, seleccione el tipo de contenido',
            selectPublishTime: 'Por favor, seleccione la hora de publicación',
            submitSuccess: 'Envío exitoso',
            submitFailed: 'Error en el envío'
        }
    },
    fr: {
        title: 'Centre de Soumission pour Créateurs',
        subtitle: 'Creator Submission Portal',
        category: 'Catégorie de Travail',
        video: 'Vidéo',
        imageText: 'Image/Texte',
        publishTime: 'Heure de Publication',
        selectTime: 'Sélectionner une heure',
        link: 'Lien de la Publication sur les Réseaux Sociaux',
        supported: 'Pris en charge : YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Remarque : Le contenu doit inclure "weryai.com/creation/"',
        submit: 'Soumettre pour Audit',
        auditInfo: 'Veuillez vous assurer que votre publication sur les réseaux sociaux est publique et que le contenu de la publication doit contenir un lien lié à "weryai.com".',
        messages: {
            fillLink: 'Veuillez remplir le lien',
            invalidLink: 'Format de lien invalide',
            httpsRequired: 'Veuillez soumettre un lien https',
            unsupportedHost: 'Cette plateforme n\'est pas encore prise en charge',
            selectType: 'Veuillez sélectionner le type de contenu',
            selectPublishTime: 'Veuillez sélectionner l\'heure de publication',
            submitSuccess: 'Soumission réussie',
            submitFailed: 'Échec de la soumission'
        }
    },
    de: {
        title: 'Creator-Einreichungszentrum',
        subtitle: 'Creator Submission Portal',
        category: 'Arbeitskategorie',
        video: 'Video',
        imageText: 'Bild/Text',
        publishTime: 'Veröffentlichungszeit',
        selectTime: 'Wählen Sie eine Zeit',
        link: 'Social-Media-Post-Link',
        supported: 'Unterstützt: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Hinweis: Der Inhalt muss "weryai.com/creation/" enthalten',
        submit: 'Zur Prüfung einreichen',
        auditInfo: 'Bitte stellen Sie sicher, dass Ihr Social-Media-Post öffentlich ist und dass der Inhalt des Posts unbedingt einen entsprechenden Link zu "weryai.com" enthält.',
        messages: {
            fillLink: 'Bitte füllen Sie den Link aus',
            invalidLink: 'Ungültiges Linkformat',
            httpsRequired: 'Bitte geben Sie einen https-Link an',
            unsupportedHost: 'Diese Plattform wird noch nicht unterstützt',
            selectType: 'Bitte wählen Sie den Inhaltstyp aus',
            selectPublishTime: 'Bitte wählen Sie die Veröffentlichungszeit aus',
            submitSuccess: 'Einreichung erfolgreich',
            submitFailed: 'Einreichung fehlgeschlagen'
        }
    },
    ru: {
        title: 'Центр подачи работ для авторов',
        subtitle: 'Creator Submission Portal',
        category: 'Категория работы',
        video: 'Видео',
        imageText: 'Изображение/Текст',
        publishTime: 'Время публикации',
        selectTime: 'Выберите время',
        link: 'Ссылка на пост в соцсетях',
        supported: 'Поддерживается: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Примечание: Контент должен содержать "weryai.com/creation/"',
        submit: 'Отправить на проверку',
        auditInfo: 'Пожалуйста, убедитесь, что ваш пост в социальных сетях является общедоступным и что содержание поста обязательно содержит ссылку, связанную с "weryai.com".',
        messages: {
            fillLink: 'Пожалуйста, заполните ссылку',
            invalidLink: 'Неверный формат ссылки',
            httpsRequired: 'Пожалуйста, отправьте ссылку https',
            unsupportedHost: 'Эта платформа пока не поддерживается',
            selectType: 'Пожалуйста, выберите тип контента',
            selectPublishTime: 'Пожалуйста, выберите время публикации',
            submitSuccess: 'Подача прошла успешно',
            submitFailed: 'Ошибка при подаче'
        }
    },
    pt: {
        title: 'Centro de Submissão de Criadores',
        subtitle: 'Creator Submission Portal',
        category: 'Categoria de Trabalho',
        video: 'Vídeo',
        imageText: 'Imagem/Texto',
        publishTime: 'Hora de Publicação',
        selectTime: 'Seleziona um orario',
        link: 'Link da Publicação em Redes Sociais',
        supported: 'Suportado: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Nota: O conteúdo deve incluir "weryai.com/creation/"',
        submit: 'Enviar para Auditoria',
        auditInfo: 'Certifique-se de que sua publicação nas redes sociais seja pública e que o conteúdo da publicação inclua obrigatoriamente um link relacionado a "weryai.com".',
        messages: {
            fillLink: 'Por favor, preencha o link',
            invalidLink: 'Formato de link inválido',
            httpsRequired: 'Por favor, envie um link https',
            unsupportedHost: 'Esta plataforma ainda não é suportada',
            selectType: 'Por favor, selecione o tipo de conteúdo',
            selectPublishTime: 'Por favor, selecione a hora de publicação',
            submitSuccess: 'Submissão bem-sucedida',
            submitFailed: 'Falha na submissão'
        }
    },
    it: {
        title: 'Centro di Invio per i Creatori',
        subtitle: 'Creator Submission Portal',
        category: 'Categoria di Lavoro',
        video: 'Video',
        imageText: 'Immagine/Testo',
        publishTime: 'Ora di Pubblicazione',
        selectTime: 'Seleziona un orario',
        link: 'Link del Post sui Social Media',
        supported: 'Supportato: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Nota: Il contenuto deve incluir "weryai.com/creation/"',
        submit: 'Invia per Revisione',
        auditInfo: 'Assicurati che il tuo post sui social media sia pubblico e che il contenuto del post contenga obbligatoriamente un link relativo a "weryai.com".',
        messages: {
            fillLink: 'Per favor, inserisci il link',
            invalidLink: 'Formato link non valido',
            httpsRequired: 'Per favore, invia un link https',
            unsupportedHost: 'Questa piattaforma non è ancora supportata',
            selectType: 'Per favore, seleziona il tipo de contenuto',
            selectPublishTime: 'Per favore, seleziona l\'ora di pubblicazione',
            submitSuccess: 'Invio completato con successo',
            submitFailed: 'Invio fallito'
        }
    },
    ar: {
        title: 'مركز تقديم المبدعين',
        subtitle: 'Creator Submission Portal',
        category: 'فئة العمل',
        video: 'فيديو',
        imageText: 'صورة/نص',
        publishTime: 'وقت النشر',
        selectTime: 'اختر وقتاً',
        link: 'رابط منشور التواصل الاجتماعي',
        supported: 'المنصات المدعومة: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'ملاحظة: يجب أن يتضمن المحتوى "weryai.com/creation/"',
        submit: 'إرسال للمراجعة',
        auditInfo: 'يرجى التأكد من أن منشورك على وسائل التواصل الاجتماعي عام، وأن محتوى المنشور يجب أن يتضمن رابطاً ذا صلة بـ "weryai.com".',
        messages: {
            fillLink: 'يرجى ملء الرابط',
            invalidLink: 'تنسيق الرابط غير صالح',
            httpsRequired: 'يرجى تقديم رابط https',
            unsupportedHost: 'هذه المنصة غير مدعومة بعد',
            selectType: 'يرجى اختيار نوع المحتوى',
            selectPublishTime: 'يرجى اختيار وقت النشر',
            submitSuccess: 'تم التقديم بنجاح',
            submitFailed: 'فشل التقديم'
        }
    },
    tw: {
        title: '作品提交中心',
        subtitle: 'Creator Submission Portal',
        category: '作品分類',
        video: '影片',
        imageText: '圖文',
        publishTime: '發布時間',
        selectTime: '選擇時間',
        link: '社群貼文連結',
        supported: '支援平台: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: '注意: 內容必須包含 "weryai.com/creation/"',
        submit: '提交審核',
        auditInfo: '請確保您的社群媒體貼文為公開，且貼文內容必須包含與 "weryai.com" 相關的連結。',
        messages: {
            fillLink: '請填寫連結',
            invalidLink: '連結格式不正確',
            httpsRequired: '請提交 https 連結',
            unsupportedHost: '暫不支援該平台',
            selectType: '請選擇內容類型',
            selectPublishTime: '請選擇發布時間',
            submitSuccess: '提交成功',
            submitFailed: '提交失敗'
        }
    },
    pl: {
        title: 'Centrum zgłaszania prac',
        subtitle: 'Creator Submission Portal',
        category: 'Kategoria pracy',
        video: 'Wideo',
        imageText: 'Obraz/Tekst',
        publishTime: 'Czas publikacji',
        selectTime: 'Wybierz czas',
        link: 'Link do posta w mediach społecznościowych',
        supported: 'Obsługiwane: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Uwaga: Treść musi zawierać "weryai.com/creation/"',
        submit: 'Wyślij do weryfikacji',
        auditInfo: 'Upewnij się, że Twój post w mediach społecznościowych jest publiczny, a treść posta musi zawierać powiązany link do "weryai.com".',
        messages: {
            fillLink: 'Wprowadź link',
            invalidLink: 'Nieprawidłowy format linku',
            httpsRequired: 'Prześlij link https',
            unsupportedHost: 'Ta platforma nie jest jeszcze obsługiwana',
            selectType: 'Wybierz typ treści',
            selectPublishTime: 'Wybierz czas publikacji',
            submitSuccess: 'Zgłoszenie wysłane pomyślnie',
            submitFailed: 'Nie udało się wysłać zgłoszenia'
        }
    },
    th: {
        title: 'ศูนย์ส่งผลงานของครีเอเตอร์',
        subtitle: 'Creator Submission Portal',
        category: 'หมวดหมู่ผลงาน',
        video: 'วิดีโอ',
        imageText: 'ภาพ/ข้อความ',
        publishTime: 'เวลาที่เผยแพร่',
        selectTime: 'เลือกเวลา',
        link: 'ลิงก์โพสต์โซเชียลมีเดีย',
        supported: 'รองรับ: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'หมายเหตุ: เนื้อหาต้องมี "weryai.com/creation/"',
        submit: 'ส่งเพื่อตรวจสอบ',
        auditInfo: 'โปรดตรวจสอบให้แน่ใจว่าโพสต์โซเชียลมีเดียของคุณเป็นสาธารณะ และเนื้อหาโพสต์ต้องมีลิงก์ที่เกี่ยวข้องกับ "weryai.com".',
        messages: {
            fillLink: 'โปรดกรอกลิงก์',
            invalidLink: 'รูปแบบลิงก์ไม่ถูกต้อง',
            httpsRequired: 'โปรดส่งลิงก์ https',
            unsupportedHost: 'ยังไม่รองรับแพลตฟอร์มนี้',
            selectType: 'โปรดเลือกประเภทเนื้อหา',
            selectPublishTime: 'โปรดเลือกเวลาที่เผยแพร่',
            submitSuccess: 'ส่งสำเร็จ',
            submitFailed: 'ส่งไม่สำเร็จ'
        }
    },
    da: {
        title: 'Indsendelsescenter for skabere',
        subtitle: 'Creator Submission Portal',
        category: 'Værkkategori',
        video: 'Video',
        imageText: 'Billede/Tekst',
        publishTime: 'Udgivelsestid',
        selectTime: 'Vælg et tidspunkt',
        link: 'Link til opslag på sociale medier',
        supported: 'Understøttet: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Bemærk: Indholdet skal indeholde "weryai.com/creation/"',
        submit: 'Indsend til gennemgang',
        auditInfo: 'Sørg for, at dit opslag på sociale medier er offentligt, og at indholdet af opslaget skal indeholde et relevant link til "weryai.com".',
        messages: {
            fillLink: 'Udfyld venligst linket',
            invalidLink: 'Ugyldigt linkformat',
            httpsRequired: 'Indsend venligst et https-link',
            unsupportedHost: 'Denne platform understøttes endnu ikke',
            selectType: 'Vælg venligst indholdstype',
            selectPublishTime: 'Vælg venligst udgivelsestidspunkt',
            submitSuccess: 'Indsendelse lykkedes',
            submitFailed: 'Indsendelse mislykkedes'
        }
    },
    no: {
        title: 'Innsendingssenter for skapere',
        subtitle: 'Creator Submission Portal',
        category: 'Verkkategori',
        video: 'Video',
        imageText: 'Bilde/Tekst',
        publishTime: 'Publiseringstid',
        selectTime: 'Velg et tidspunkt',
        link: 'Lenke til innlegg på sosiale medier',
        supported: 'Støttet: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Merk: Innholdet må inneholde "weryai.com/creation/"',
        submit: 'Send inn til vurdering',
        auditInfo: 'Sørg for at innlegget ditt på sosiale medier er offentlig, og at innholdet i innlegget må inneholde en relevant lenke til "weryai.com".',
        messages: {
            fillLink: 'Vennligst fyll inn lenken',
            invalidLink: 'Ugyldig lenkeformat',
            httpsRequired: 'Vennligst send inn en https-lenke',
            unsupportedHost: 'Denne plattformen støttes ikke ennå',
            selectType: 'Vennligst velg innholdstype',
            selectPublishTime: 'Vennligst velg publiseringstid',
            submitSuccess: 'Innsending vellykket',
            submitFailed: 'Innsending mislyktes'
        }
    },
    nl: {
        title: 'Inzendcentrum voor makers',
        subtitle: 'Creator Submission Portal',
        category: 'Werkcategorie',
        video: 'Video',
        imageText: 'Afbeelding/Tekst',
        publishTime: 'Publicatietijd',
        selectTime: 'Selecteer een tijd',
        link: 'Link naar socialmediapost',
        supported: 'Ondersteund: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Let op: De inhoud moet "weryai.com/creation/" bevatten',
        submit: 'Indienen voor controle',
        auditInfo: 'Zorg ervoor dat je socialmediapost openbaar is en dat de inhoud van de post een gerelateerde link naar "weryai.com" moet bevatten.',
        messages: {
            fillLink: 'Vul de link in',
            invalidLink: 'Ongeldig linkformaat',
            httpsRequired: 'Stuur een https-link',
            unsupportedHost: 'Dit platform wordt nog niet ondersteund',
            selectType: 'Selecteer het contenttype',
            selectPublishTime: 'Selecteer de publicatietijd',
            submitSuccess: 'Indienen geslaagd',
            submitFailed: 'Indienen mislukt'
        }
    },
    id: {
        title: 'Pusat Pengiriman Kreator',
        subtitle: 'Creator Submission Portal',
        category: 'Kategori Karya',
        video: 'Video',
        imageText: 'Gambar/Teks',
        publishTime: 'Waktu Publikasi',
        selectTime: 'Pilih waktu',
        link: 'Tautan Postingan Media Sosial',
        supported: 'Didukung: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Catatan: Konten harus menyertakan "weryai.com/creation/"',
        submit: 'Kirim untuk Ditinjau',
        auditInfo: 'Pastikan postingan media sosial Anda bersifat publik, dan konten postingan harus menyertakan tautan terkait ke "weryai.com".',
        messages: {
            fillLink: 'Silakan isi tautan',
            invalidLink: 'Format tautan tidak valid',
            httpsRequired: 'Silakan kirim tautan https',
            unsupportedHost: 'Platform ini belum didukung',
            selectType: 'Silakan pilih jenis konten',
            selectPublishTime: 'Silakan pilih waktu publikasi',
            submitSuccess: 'Pengiriman berhasil',
            submitFailed: 'Pengiriman gagal'
        }
    },
    tr: {
        title: 'Yaratıcı Gönderim Merkezi',
        subtitle: 'Creator Submission Portal',
        category: 'Eser Kategorisi',
        video: 'Video',
        imageText: 'Görsel/Metin',
        publishTime: 'Yayın Zamanı',
        selectTime: 'Bir zaman seçin',
        link: 'Sosyal Medya Gönderisi Bağlantısı',
        supported: 'Desteklenen: YouTube, Instagram, X, Reddit, Medium, Note.com.',
        note: 'Not: İçerik "weryai.com/creation/" içermelidir',
        submit: 'İncelemeye Gönder',
        auditInfo: 'Lütfen sosyal medya gönderinizin herkese açık olduğundan emin olun ve gönderi içeriği "weryai.com" ile ilgili bir bağlantı içermelidir.',
        messages: {
            fillLink: 'Lütfen bağlantıyı girin',
            invalidLink: 'Geçersiz bağlantı biçimi',
            httpsRequired: 'Lütfen bir https bağlantısı gönderin',
            unsupportedHost: 'Bu platform henüz desteklenmiyor',
            selectType: 'Lütfen içerik türünü seçin',
            selectPublishTime: 'Lütfen yayın zamanını seçin',
            submitSuccess: 'Gönderim başarılı',
            submitFailed: 'Gönderim başarısız'
        }
    }
}
